// extracted by mini-css-extract-plugin
export default {"left-move":"Dashboard_left-move__6DgoW"};